import { getDateFormat } from "../helpers/helper";
export class Device {
  _id;
  createdAt;
  doctor;
  patient;
  state;

  constructor(_id, createdAt, doctor, patient) {
    this._id = _id;
    this.createdAt = getDateFormat(createdAt);
    this.doctor = doctor;
    this.patient = patient;
    this.state = false;
  }
}
